/*
 * Bisou Rivage — deux pages en plus simple (version ALT, 17/10/2026). Va avec bisou-alt-simple.css.
 *   1. « Composer mon mur » au téléphone : mode simple par défaut, « Réglages » rouvre tout (mémorisé
 *      le temps de la visite).
 *   2. La liste d'envies : cartes épurées (« À partir de », un cœur pour retirer), barre « Composer mon mur » ;
 *      depuis le 20/10, une introduction en tête et un vrai bouton « Partager ma liste ».
 * S'efface en « Avant » (classe bvf-off sur <html>) : les textes d'origine reviennent, les ajouts se cachent.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  function isOff() { return root.classList.contains('bvf-off'); }
  function isEn() { return /^en/i.test(root.getAttribute('lang') || ''); }
  /* 26/10 (langues) : fr, en, es ou ja ; une autre langue garde le français, comme avant */
  function langue() { var l = (root.getAttribute('lang') || '').slice(0, 2).toLowerCase(); return isEn() ? 'en' : (l === 'es' || l === 'ja' ? l : 'fr'); }
  function safe(fn) { try { fn(); } catch (e) { if (window.console) console.warn('[bvf-simple]', e); } }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    n.setAttribute('data-bvf-s', '');
    return n;
  }
  var modeFns = [];
  if (window.MutationObserver) {
    var lastOff = isOff();
    new MutationObserver(function () {
      var off = isOff();
      if (off === lastOff) return;
      lastOff = off;
      modeFns.forEach(function (fn) { safe(fn); });
    }).observe(root, { attributes: true, attributeFilter: ['class'] });
  }
  function refit() { setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 40); }

  /* ---------- 1. Composer mon mur ---------- */
  safe(function () {
    var P = document.getElementById('BRPlanner');
    if (!P || !P.classList.contains('brp-app')) return;
    root.classList.add('bvf-s-mur');
    /* La consigne dit le geste de l'appareil : « Cliquez » à la souris, « Touchez » au doigt */
    var mouse = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
    var T = isEn()
      ? { title: 'Plan my wall', hint: (mouse ? 'Click' : 'Tap') + ' a frame to adjust it, or its name to see the print.', more: 'Settings', less: 'Simple', fmt: 'Size', frm: 'Frame' }
      : { title: P.dataset.nom || 'Côte à côte', hint: (mouse ? 'Cliquez' : 'Touchez') + ' un cadre pour le régler, ou son nom pour voir le tirage.', more: 'Réglages', less: 'Simple', fmt: 'Format', frm: 'Cadre' };
    /* es, ja (26/10) : les textes viennent de BRPlanner.lang (planner.simple_*, print_col_format, frame_color) ;
       la table ci-dessus reste le repli si le pont manque */
    var PL = (window.BRPlanner && window.BRPlanner.lang) || {};
    [['title', 'simple_title'], ['hint', mouse ? 'simple_hint_click' : 'simple_hint_tap'], ['more', 'simple_more'], ['less', 'simple_less'],
      ['fmt', 'print_col_format'], ['frm', 'frame_color']].forEach(function (k) { if (typeof PL[k[1]] === 'string' && PL[k[1]]) T[k[0]] = PL[k[1]]; });
    /* Le message de « Perso » dit aussi le geste : « Touchez » au doigt. Lu à l'affichage dans BRPlanner.lang ;
       le texte d'origine revient en « Avant » */
    var lang = window.BRPlanner && window.BRPlanner.lang;
    if (lang && !mouse) {
      var persoA = lang.toast_custom_hint, persoB = lang.simple_perso_tap || (isEn() ? 'Tap a frame on the wall to customise it' : 'Touchez un cadre sur le mur pour le personnaliser');
      Object.defineProperty(lang, 'toast_custom_hint', { configurable: true, enumerable: true, get: function () { return isOff() ? persoA : persoB; } });
    }

    /* Le titre et la consigne : en clair, et rendus tels quels en « Avant » */
    var swaps = [];
    function swap(node, text) { if (node) swaps.push({ n: node, a: node.textContent, b: text }); }
    swap(P.querySelector('.brp-masthead__title'), T.title);
    swap(P.querySelector('#brpSelHint'), T.hint);
    function texts() { var off = isOff(); swaps.forEach(function (s) { s.n.textContent = off ? s.a : s.b; }); }
    texts();
    modeFns.push(texts);

    /* Les trois groupes du volet : le compteur part, format et cadre gardent un nom court */
    function mark(sel, cls, label) {
      var x = P.querySelector(sel), g = x && x.closest('.br-optgroup');
      if (!g) return;
      g.classList.add(cls);
      if (label && !g.querySelector('.bvf-pl-lbl')) g.insertBefore(el('span', 'bvf-pl-lbl', label), g.firstChild);
    }
    mark('#brpDispo', 'bvf-pl-x');
    mark('#brpSize', 'bvf-pl-fmt', T.fmt);
    mark('#brpFrameG', 'bvf-pl-frm', T.frm);

    /* « Réglages » : tout le simulateur d'avant, d'un geste ; « Simple » y revient */
    var KEY = 'bvf_pl_all';
    try { if (sessionStorage.getItem(KEY) === '1') P.classList.add('bvf-pl-all'); } catch (e) {}
    var head = P.querySelector('.brp-masthead');
    if (head && !head.querySelector('.bvf-pl-more')) {
      var b = el('button', 'bvf-pl-more');
      b.type = 'button';
      var label = function () {
        var all = P.classList.contains('bvf-pl-all');
        b.textContent = all ? T.less : T.more;
        b.setAttribute('aria-pressed', all ? 'true' : 'false');
      };
      label();
      b.addEventListener('click', function () {
        P.classList.toggle('bvf-pl-all');
        try { sessionStorage.setItem(KEY, P.classList.contains('bvf-pl-all') ? '1' : '0'); } catch (e) {}
        label();
        refit();
      });
      head.appendChild(b);
    }
    /* Le mur se recalcule quand le volet change de taille */
    modeFns.push(refit);
    refit();
    window.addEventListener('load', refit);
  });

  /* ---------- 2. La liste d'envies ---------- */
  safe(function () {
    var body = document.querySelector('.bwl__body');
    if (!body) return;
    /* Une liste partagée (?items=…) garde l'écran d'origine : ce ne sont pas les tirages du visiteur */
    if (/[?&](items|shared|share)=/.test(location.search)) return;
    root.classList.add('bvf-s-wish');
    body.classList.add('bvf-wl1');
    var en = isEn(), LG = langue();
    /* Le nom de l'outil du mur va changer (question posée à Max le 20/10) : c'est la seule ligne à modifier
       (es, ja : le nom que porte la page, planner.simple_title) */
    var WALL = en ? 'Side by side' : LG === 'es' ? 'Lado a lado' : LG === 'ja' ? '並べて飾る' : 'Côte à côte';
    /* 29/10 (c29t-favoris, Max : « trop de texte ») : plus de titre ni de phrase autour de « Côte à côte » et du partage */
    var T = en
      ? { from: 'From', out: 'Sold out', one: '1 print', many: ' prints', duo: WALL, wall: WALL, share: 'Share my list' }
      : { from: 'À partir de', out: 'Épuisé', one: '1 tirage', many: ' tirages', duo: 'Côte à côte', wall: WALL, share: 'Partager ma liste' };
    /* es, ja (26/10) : mêmes mots que TR_LANGUE de bisou-alt.js et les fichiers de langue
       (wishlist.share_list, wishlist.sold_out, rail.from_html). {p} = le prix, à la place que lui donne la langue.
       27/10 (langues, liste d'envies) : l'espagnol tutoie, comme tout le site (« Encuéntrale », « tu pared ») */
    T = {
      es: { from: 'Desde {p}', out: 'Agotado', one: '1\u00a0lámina', many: '\u00a0láminas', duo: WALL, wall: WALL, share: 'Compartir mi lista' },
      ja: { from: '{p}から', out: '完売', one: '1点の​プリント', many: '点の​プリント', duo: WALL, wall: WALL, share: 'お気に入りを共有' }
    }[LG] || T;
    var PLANNER = (en ? '/en' : LG === 'fr' ? '' : '/' + LG) + '/pages/framed-wall-planner';

    function items() {
      var list = [];
      try {
        if (window.BisouWishlist && typeof window.BisouWishlist.read === 'function') list = window.BisouWishlist.read();
        else { var d = JSON.parse(localStorage.getItem('br_wishlist_v1')); list = d && Array.isArray(d.items) ? d.items : []; }
      } catch (e) { list = []; }
      return list.slice().sort(function (a, b) { return (b.at || 0) - (a.at || 0); }).filter(function (i) { return i && i.h; });
    }
    function money(cents) {
      /* 28/10 (c28b-prix-devise-favoris-cac) : hors euro (région Japon, États-Unis…), la devise active, écrite comme
         les cartes de la boutique (« ¥17,100 », « $109.00 ») ; les prix reçus sont déjà convertis. */
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      if (cur !== 'EUR') {
        try { return new Intl.NumberFormat('en', { style: 'currency', currency: cur }).format((cents || 0) / 100); } catch (e) { /* repli */ }
      }
      var v = Math.round(cents) / 100;
      var s = Math.round(v) === v ? String(v) : v.toFixed(2);
      /* « 35 € » : l'espace avant l'euro est insécable, comme sur les pages de collection (25/10) */
      /* 29/10 (c29t-favoris) : en anglais aussi, « 229,50 € » : écrit « €229.50 », la partie 6 de bisou-ventes-fidelite.js
         le récrivait à moitié (« 229 €.50 ») ; les prix ronds (« €270 » → « 270 € ») sortaient déjà ainsi */
      return s.replace('.', ',') + ' €';
    }

    /* Le cadre et le format choisis dans le volet sont gardés le temps de la visite : ouvrir un tirage puis
       revenir ne remet plus chaque carte au choix par défaut (24/10) */
    var SEL = 'bvf_wl1_sel';
    function sels() { try { return JSON.parse(sessionStorage.getItem(SEL)) || {}; } catch (e) { return {}; } }
    function keepSel(c) {
      var h = c.getAttribute('data-bwl-handle'), f = c.querySelector('.bwl-sel--frame'), z = c.querySelector('.bwl-sel--format');
      if (!h) return;
      var m = sels();
      m[h] = { f: f ? f.value : null, z: z ? z.value : null };
      try { sessionStorage.setItem(SEL, JSON.stringify(m)); } catch (e) {}
    }
    /* Une carte dont le client a choisi le cadre ou le format ouvre la fiche sur ce choix : sinon la fiche
       repart sur son défaut (A3 noir), un autre prix (24/10) */
    function linkSel(c) {
      var a = c.querySelector('.bwl-item__add'), id = a && !a.disabled && a.getAttribute('data-variant');
      Array.prototype.forEach.call(c.querySelectorAll('a.bwl-item__media, .bwl-item__title a'), function (l) {
        var u = l.getAttribute('href');
        if (u) l.setAttribute('href', u.split('?')[0] + (id ? '?variant=' + id : ''));
      });
    }
    function restoreSel(c) {
      var k = sels()[c.getAttribute('data-bwl-handle')], done = false;
      if (!k) return false;
      [['frame', k.f], ['format', k.z]].forEach(function (x) {
        var s = c.querySelector('.bwl-sel--' + x[0]);
        if (!s || x[1] == null || s.value === x[1]) return;
        if (!Array.prototype.some.call(s.options, function (o) { return o.value === x[1]; })) return;
        s.value = x[1];
        s.dispatchEvent(new Event('change', { bubbles: true }));
        done = true;
      });
      return done;
    }

    /* Chaque carte : « À partir de » sous le titre, comme sur les collections */
    function deco(card) {
      if (card.getAttribute('data-bvf-wl1') || !card._p) return;
      card.setAttribute('data-bvf-wl1', '1');
      /* un choix gardé : la carte le reprend, et montre ce choix plutôt que l'A2 */
      var kept = !isOff() && restoreSel(card);
      /* un choix gardé égal au défaut de la carte ne change rien à reprendre : le lien porte quand même ce choix (25/10) */
      if (!isOff() && sels()[card.getAttribute('data-bwl-handle')]) linkSel(card);
      var p = card._p, info = card.querySelector('.bwl-item__info');
      var cents = p.price_min != null ? p.price_min : p.price;
      if (!info || cents == null) return;
      /* Un tirage épuisé le dit sur sa carte : sinon rien ne le distingue des autres jusqu'au volet du panier (24/10) */
      var from = el('p', 'bvf-wl1-from', p.available === false ? T.out : T.from.indexOf('{p}') < 0 ? T.from + ' ' + money(cents) : T.from.replace('{p}', money(cents)));
      var title = info.querySelector('.bwl-item__title');
      if (title && title.nextSibling) info.insertBefore(from, title.nextSibling); else info.appendChild(from);
      if (wide && !kept) showA2(card, p);
    }
    /* (23/10, Max : « mets pas les images en A4 encadré mais en A2 encadré ! ») À l'ordinateur, la carte montre
       le même tirage, même cadre, en A2. Seule l'image change : le choix d'achat de la carte (caché ici) reste le sien */
    var wide = !!(window.matchMedia && window.matchMedia('(min-width: 750px)').matches);
    function base(src) { return String(src || '').split('?')[0].split('/').pop(); }
    function showA2(card, p) {
      var img = card.querySelector('[data-bwl-img]');
      if (!img || !p.variants || !p.options) return;
      var now = base(img.getAttribute('src')), cur = null, fi = -1, i, j;
      for (i = 0; i < p.variants.length; i++) {
        var fv = p.variants[i].featured_image;
        if (fv && base(fv.src) === now) { cur = p.variants[i]; break; }
      }
      if (!cur) return;
      for (j = 0; j < 3; j++) if (/^A\d\b/i.test(cur['option' + (j + 1)] || '')) fi = j;
      if (fi < 0 || /^A2\b/i.test(cur['option' + (fi + 1)])) return;
      for (i = 0; i < p.variants.length; i++) {
        var w = p.variants[i], ok = /^A2\b/i.test(w['option' + (fi + 1)] || '') && w.featured_image && w.featured_image.src;
        for (j = 0; ok && j < 3; j++) if (j !== fi && w['option' + (j + 1)] !== cur['option' + (j + 1)]) ok = false;
        if (ok) {
          var src = w.featured_image.src;
          img.setAttribute('data-bvf-a2', src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=720');
          img.setAttribute('data-bvf-src', img.getAttribute('src'));
          if (img.hasAttribute('srcset')) img.setAttribute('data-bvf-srcset', img.getAttribute('srcset'));
          paintA2(img);
          return;
        }
      }
    }
    /* L'A2 en « Après » ; l'image d'origine de la carte revient en « Avant » */
    function paintA2(img) {
      var off = isOff(), want = img.getAttribute(off ? 'data-bvf-src' : 'data-bvf-a2');
      if (!want || img.getAttribute('src') === want) return;
      img.src = want;
      if (off && img.hasAttribute('data-bvf-srcset')) img.setAttribute('srcset', img.getAttribute('data-bvf-srcset'));
      else img.removeAttribute('srcset');
    }
    function decoAll() { Array.prototype.forEach.call(body.querySelectorAll('.bwl-item'), deco); }

    /* La barre du bas, créée retirée : l'observateur plus bas la montre (sinon, elle clignote à l'ouverture).
       29/10 (c29t-favoris) : elle vit au bout de la liste, collée au bas de l'écran (sticky) : elle flotte tant que la
       liste continue, puis se pose sous la liste, au-dessus du pied de page, qu'elle couvrait (« S'abonner »). Une
       liste courte la montre posée sous la liste, sans rien couvrir */
    var ARROW = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3 8h10M9 4l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    var bar = el('div', 'bvf-wl1-bar' + (window.IntersectionObserver ? ' is-away' : ''));
    bar.innerHTML = '<span class="bvf-wl1-bar__left"><span class="bvf-wl1-bar__head"><span class="bvf-wl1-bar__n"></span></span></span><a class="bvf-wl1-bar__go" href="' + PLANNER + '"><span></span>' + ARROW + '</a>';
    bar.querySelectorAll('*').forEach(function (n) { n.removeAttribute('data-bvf-s'); });
    body.appendChild(bar);
    var nEl = bar.querySelector('.bvf-wl1-bar__n'), go = bar.querySelector('.bvf-wl1-bar__go'), goT = go.querySelector('span');

    /* (23/10, Max : « ajoute aussi le truc de réduction, genre −10 % et les autres jusqu'à 5 en mode grisé ») Les
       paliers de lot du panier (réglage de bisou-ventes-fidelite, p2 à p5), sous le nombre de tirages : atteint en
       noir, passés cochés, à venir en gris. Seulement les paliers réglés, et, comme au panier, seulement si l'offre
       est en ligne ou en aperçu */
    /* (28/10, Max : « grossir le moins 10, moins 20 pour faire exactement comme Bambu Lab […] une ligne, comme pour la
       livraison qui est offerte ») Chaque palier a sa part d'une ligne de progression, son pourcentage en gros et, à
       l'ordinateur, « dès N tirages » dessous ; la phrase du haut dit ce qu'il manque pour le palier suivant */
    var steps = null, OFFER = {}, msgEl = null;
    var PCT = function (p) { return '−' + p + (en || LG === 'ja' ? '%' : ' %'); };
    var TP = en
      ? { more: function (k, p) { return k === 1 ? 'One more print for ' + p : k + ' more prints for ' + p; }, top: 'Top tier reached: {p}', min: '{n}+ prints' }
      : { more: function (k, p) { return 'Encore ' + k + ' tirage' + (k > 1 ? 's' : '') + ' pour ' + p; }, top: 'Plus haut palier atteint : {p}', min: 'dès {n} tirages' };
    TP = {
      es: { more: function (k, p) { return (k === 1 ? 'Te falta 1 lámina' : 'Te faltan ' + k + ' láminas') + ' para ' + p; }, top: 'Nivel máximo alcanzado: {p}', min: 'desde {n} láminas' },
      ja: { more: function (k, p) { return 'あと' + k + '点で' + p; }, top: '最大の割引：{p}', min: '{n}点から' }
    }[LG] || TP;
    try { OFFER = (JSON.parse((document.getElementById('bvf-config') || {}).textContent || '{}').offer) || {}; } catch (e) { OFFER = {}; }
    var preview = !!(window.Shopify && ((window.Shopify.theme && window.Shopify.theme.role && window.Shopify.theme.role !== 'main') || window.Shopify.designMode));
    var tiers = [];
    if (OFFER.live || preview) [2, 3, 4, 5].forEach(function (k) { var p = Number(OFFER['p' + k]) || 0; if (p > 0) tiers.push({ n: k, pct: p }); });
    if (tiers.length) {
      steps = document.createElement('span');
      steps.className = 'bvf-wl1-bar__steps';
      if (!OFFER.live && OFFER.preview) steps.title = OFFER.preview;
      tiers.forEach(function (t) {
        var s = document.createElement('span');
        s.className = 'bvf-wl1-bar__step';
        s.setAttribute('data-n', t.n);
        s.innerHTML = '<i class="bvf-wl1-bar__seg" aria-hidden="true"><i></i></i><b class="bvf-wl1-bar__pct"></b><small class="bvf-wl1-bar__min"></small>';
        s.querySelector('b').textContent = PCT(t.pct);
        s.querySelector('small').textContent = TP.min.replace('{n}', t.n);
        s.setAttribute('aria-label', en ? '−' + t.pct + '% from ' + t.n + ' prints' : LG === 'es' ? '−' + t.pct + ' % desde ' + t.n + ' láminas'
          : LG === 'ja' ? t.n + '点以上で−' + t.pct + '%' : '−' + t.pct + ' % dès ' + t.n + ' tirages');
        steps.appendChild(s);
      });
      var head = bar.querySelector('.bvf-wl1-bar__head');
      msgEl = document.createElement('span');
      msgEl.className = 'bvf-wl1-bar__msg';
      head.appendChild(msgEl);
      if (!OFFER.live) head.appendChild(el('span', 'bvf-wl1-bar__apercu', en ? 'preview' : LG === 'es' ? 'vista previa' : LG === 'ja' ? 'プレビュー' : 'aperçu'));
      bar.querySelector('.bvf-wl1-bar__left').appendChild(steps);
      /* au téléphone, les paliers prennent leur propre rangée ; à l'ordinateur, la barre s'élargit pour une ligne */
      bar.classList.add('has-steps');
    }
    /* (23/10, Max : « ça faudrait presque l'ajouter dans le panier ») « Tout au panier » dans la barre : un volet
       montre chaque tirage avec le cadre, le format et le prix qui partent au panier, modifiables, et le total.
       « Ajouter » passe par le « Tout ajouter au panier » d'origine (caché ici), qui met au panier le choix de
       chaque carte, et son code de palier s'il est réglé. Rien ne part sans avoir été montré : à l'ordinateur, la
       carte montre l'A2, la ligne dit le format choisi ; un format changé ici change aussi l'image de la carte */
    var origAll = body.querySelector('[data-bwl-add-all]'), all = null, sheet = null;
    var TA = en
      ? { all: 'Add all to cart', t: 'Add to cart', s: 'Choose the frame and size of each print.', out: 'Sold out', close: 'Close', one: 'Add 1 print', many: 'Add {n} prints', ship: 'Free delivery in France from €150' }
      : { all: 'Tout au panier', t: 'Ajouter au panier', s: 'Choisissez le cadre et le format de chaque tirage.', out: 'Épuisé', close: 'Fermer', one: 'Ajouter 1 tirage', many: 'Ajouter {n} tirages', ship: 'Livraison offerte en France dès 150 €' };
    TA = {
      es: { all: 'Todo a la cesta', t: 'Añadir a la cesta', s: 'Elige el marco y el formato de cada lámina.', out: 'Agotado', close: 'Cerrar', one: 'Añadir 1 lámina', many: 'Añadir {n} láminas', ship: 'Envío gratis en Francia desde 150 €' },
      ja: { all: 'まとめてカートへ', t: 'カートに追加', s: 'プリントごとに、​フレームと​サイズを​選んでください。', out: '完売', close: '閉じる', one: '1点をカートに追加', many: '{n}点をカートに追加', ship: 'フランス国内は150 €以上で送料無料' }
    }[LG] || TA;
    if (origAll) {
      all = document.createElement('button');
      all.type = 'button';
      all.className = 'bvf-wl1-bar__all';
      all.setAttribute('aria-haspopup', 'dialog');
      all.setAttribute('aria-expanded', 'false');
      all.setAttribute('aria-label', TA.all);
      all.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 8h14l-1.2 11.2a1 1 0 0 1-1 .8H7.2a1 1 0 0 1-1-.8z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg><span></span>';
      all.querySelector('span').textContent = TA.all;
      bar.insertBefore(all, go);
      sheet = el('div', 'bvf-wl1-sheet');
      sheet.setAttribute('role', 'dialog');
      sheet.setAttribute('aria-label', TA.t);
      sheet.hidden = true;
      sheet.innerHTML = '<div class="bvf-wl1-sheet__head"><div><p class="bvf-wl1-sheet__t"></p><p class="bvf-wl1-sheet__s"></p></div>' +
        '<button type="button" class="bvf-wl1-sheet__x"><svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button></div>' +
        '<ul class="bvf-wl1-sheet__list" role="list"></ul><p class="bvf-wl1-sheet__ship"></p><button type="button" class="bvf-wl1-sheet__go"></button>';
      sheet.querySelector('.bvf-wl1-sheet__t').textContent = TA.t;
      /* (Max : « indiquer les frais de port offerts », panier, wishlist, mon espace) Dite là où l'on décide, juste
         au-dessus du bouton qui ajoute. Mot pour mot le bandeau du haut (annonce_msg_1 et sa traduction anglaise) :
         la livraison n'est offerte qu'en France depuis le 19/10. Le seuil, 150 €, est écrit en dur, comme dans le
         bandeau : il ne suit pas le réglage bisou_free_shipping_threshold. Dit tel quel, sans calcul : les paliers de
         lot changent le total au panier.
         29/10 (c29-livraison-offerte-devise) : dite seulement à un visiteur de France ; en anglais, « 150 € » comme les
         prix de la page (plus de data-bvf-keep : la partie 6 de bisou-ventes-fidelite.js récrit « €150 ») */
      var shipP = sheet.querySelector('.bvf-wl1-sheet__ship');
      if (window.Shopify && Shopify.country === 'FR') shipP.textContent = TA.ship;
      else shipP.style.display = 'none';
      sheet.querySelector('.bvf-wl1-sheet__s').textContent = TA.s;
      sheet.querySelector('.bvf-wl1-sheet__x').setAttribute('aria-label', TA.close);
      document.body.appendChild(sheet);
      var sList = sheet.querySelector('.bvf-wl1-sheet__list'), sGo = sheet.querySelector('.bvf-wl1-sheet__go');
      var shown = function (c) { var a = c.querySelector('.bwl-item__add'); return a && !a.disabled && a.getAttribute('data-variant') ? a.getAttribute('data-variant') : ''; };
      var fillRow = function (li, c) {
        var id = shown(c), v = null, i;
        for (i = 0; id && i < c._p.variants.length; i++) if (String(c._p.variants[i].id) === id) v = c._p.variants[i];
        var im = li.querySelector('img'), src = (v && v.featured_image && v.featured_image.src) || '';
        if (src) im.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        /* Un épuisé n'a pas de variante en vente : sa ligne prend l'image de sa carte, plutôt qu'un carré vide (24/10) */
        else { var ci = c.querySelector('[data-bwl-img]'); if (ci && ci.getAttribute('src')) im.src = ci.getAttribute('src'); }
        li.querySelector('.bvf-wl1-sheet__p').textContent = v ? money(v.price) : TA.out;
        li.classList.toggle('is-out', !v);
      };
      var sum = function () {
        var n = 0, cents = 0;
        Array.prototype.forEach.call(sList.children, function (li) {
          var c = li._c, id = shown(c), i;
          if (!id) return;
          for (i = 0; i < c._p.variants.length; i++) if (String(c._p.variants[i].id) === id) { n++; cents += c._p.variants[i].price; }
        });
        sGo.disabled = !n;
        sGo.textContent = (n === 1 ? TA.one : TA.many.replace('{n}', n)) + (n ? ' · ' : '');
        if (!n) return;
        /* 29/10 (c29t-favoris) : le prix que dira le panier, avec la remise de lot que la barre annonce (même palier,
           même réglage) ; le prix d'avant barré, comme au panier. La devise est celle de money() */
        var pct = 0;
        tiers.forEach(function (t) { if (n >= t.n) pct = t.pct; });
        if (pct) {
          var was = document.createElement('s');
          was.className = 'bvf-wl1-sheet__was';
          was.setAttribute('aria-hidden', 'true');
          was.textContent = money(cents);
          sGo.appendChild(was);
          cents = Math.round(cents * (100 - pct) / 100);
        }
        sGo.appendChild(document.createTextNode(money(cents)));
      };
      var proxy = function (c, li, cls) {
        var cs = c.querySelector('.bwl-sel--' + cls);
        if (!cs) return null;
        var s = document.createElement('select');
        s.className = 'bvf-wl1-sheet__sel';
        s.innerHTML = cs.innerHTML;
        s.value = cs.value;
        s.setAttribute('aria-label', (cs.getAttribute('aria-label') || '') + ' — ' + (c.querySelector('.bwl-item__title') || {}).textContent);
        s.addEventListener('change', function () {
          cs.value = s.value;
          cs.dispatchEvent(new Event('change', { bubbles: true }));
          keepSel(c);
          linkSel(c);
          /* la carte montre désormais le choix fait ici, plus l'A2 */
          var ci = c.querySelector('[data-bwl-img]');
          if (ci) ['data-bvf-a2', 'data-bvf-src', 'data-bvf-srcset'].forEach(function (a) { ci.removeAttribute(a); });
          fillRow(li, c);
          sum();
        });
        return s;
      };
      var openSheet = function () {
        sList.textContent = '';
        Array.prototype.forEach.call(body.querySelectorAll('[data-bwl-grid] .bwl-item'), function (c) {
          if (!c._p) return;
          var li = document.createElement('li');
          li.className = 'bvf-wl1-sheet__row';
          li._c = c;
          li.innerHTML = '<img alt="" decoding="async"><div class="bvf-wl1-sheet__info"><p class="bvf-wl1-sheet__n"></p><div class="bvf-wl1-sheet__sels"></div></div><p class="bvf-wl1-sheet__p"></p>';
          li.querySelector('.bvf-wl1-sheet__n').textContent = c._p.title || '';
          var sels = li.querySelector('.bvf-wl1-sheet__sels');
          ['frame', 'format'].forEach(function (k) { var s = proxy(c, li, k); if (s) sels.appendChild(s); });
          fillRow(li, c);
          sList.appendChild(li);
        });
        sGo.disabled = false;
        sum();
        sheet.hidden = false;
        fitSheet();
        all.setAttribute('aria-expanded', 'true');
        sheet.querySelector('.bvf-wl1-sheet__x').focus({ preventScroll: true });
      };
      /* posée sous la liste, la barre peut être haut dans l'écran : le volet se cale sur elle (29/10) */
      var fitSheet = function () {
        if (sheet.hidden) return;
        var top = bar.getBoundingClientRect().top;
        sheet.style.bottom = Math.max(0, Math.round(window.innerHeight - top + 6)) + 'px';
        sheet.style.maxHeight = Math.max(220, Math.min(560, Math.round(top - 72))) + 'px';
      };
      window.addEventListener('scroll', fitSheet, { passive: true });
      window.addEventListener('resize', fitSheet);
      var closeSheet = function (back) {
        if (sheet.hidden) return;
        sheet.hidden = true;
        all.setAttribute('aria-expanded', 'false');
        if (back) all.focus({ preventScroll: true });
      };
      all.addEventListener('click', function () { if (sheet.hidden) openSheet(); else closeSheet(); });
      sheet.querySelector('.bvf-wl1-sheet__x').addEventListener('click', function () { closeSheet(true); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(true); });
      document.addEventListener('click', function (e) { if (!sheet.hidden && !sheet.contains(e.target) && !all.contains(e.target)) closeSheet(); });
      /* « Ajouter » : le bouton d'origine ; son texte (« Ajout… », « 4 tirages ajoutés ») s'affiche ici */
      sGo.addEventListener('click', function () { origAll.click(); });
      if (window.MutationObserver) {
        new MutationObserver(function () {
          sGo.textContent = origAll.textContent.trim();
          sGo.disabled = origAll.disabled;
          if (!origAll.disabled) setTimeout(sum, 2700);
        }).observe(origAll, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
      }
    }
    function paintSteps(n) {
      if (!steps) return;
      var on = null, next = null, lo = 0;
      tiers.forEach(function (t) { if (n >= t.n) on = t; else if (!next) next = t; });
      /* la part de chaque palier se remplit tirage après tirage : à 1 tirage, la moitié de « dès 2 » */
      Array.prototype.forEach.call(steps.querySelectorAll('.bvf-wl1-bar__step'), function (s, i) {
        var t = tiers[i], f = n >= t.n ? 1 : Math.max(0, (n - lo) / (t.n - lo));
        lo = t.n;
        s.style.setProperty('--f', f.toFixed(3));
        s.classList.toggle('is-on', !!on && t.n === on.n);
        s.classList.toggle('is-done', !!on && t.n < on.n);
        s.classList.toggle('is-next', !!next && t.n === next.n);
      });
      if (msgEl) msgEl.textContent = next ? TP.more(next.n - n, PCT(next.pct)) : TP.top.replace('{p}', PCT(on.pct));
    }

    /* L'introduction, en tête, sous le bandeau qui porte déjà le nom de la page et le compte : le mur,
       « Composer » et « Partager ma liste » (le bouton d'origine) */
    /* (23/10, Max, au téléphone : « d'abord on montre la wishlist puis le bouton partager puis une carte pour
       parler de "tester différents accrochages" ») La carte du mur (titre, phrase, petit mur des tirages gardés,
       bouton) et le partage sont deux blocs ; à l'ordinateur, ils se lisent comme avant, sur une ligne */
    var intro = el('section', 'bvf-wl1-intro');
    /* 29/10 (c29t-favoris, Max : « trop de texte », « pas centré ») : sous la liste, plus que deux boutons courts et
       centrés, « Côte à côte » et « Partager ma liste ». Plus de carte « Tester différents accrochages » (sur-titre,
       titre, phrase, petit mur) ni de phrase sous le partage */
    intro.innerHTML = '<div class="bvf-wl1-intro__card">' +
      '<a class="bvf-wl1-intro__go" href="' + PLANNER + '"><span></span>' + ARROW + '</a></div>' +
      '<div class="bvf-wl1-intro__acts">' +
      '<button type="button" class="bvf-wl1-intro__share"><svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
      '<circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>' +
      '<span></span></button></div>';
    body.insertBefore(intro, body.firstChild);
    var iGo = intro.querySelector('.bvf-wl1-intro__go'),
      iGoT = iGo.querySelector('span'), share = intro.querySelector('.bvf-wl1-intro__share');
    share.querySelector('span').textContent = T.share;
    share.addEventListener('click', function () {
      var s = body.querySelector('[data-bwl-share]');
      if (s) s.click();
    });
    var grid = body.querySelector('[data-bwl-grid]');
    /* Le bloc passe sous les tirages, au téléphone comme à l'ordinateur (29/10, c29t-favoris : en tête, à l'ordinateur,
       il poussait la première rangée sous la barre du bas, qui en couvrait les prix au premier écran) */
    if (grid) grid.parentNode.insertBefore(intro, grid.nextSibling);
    /* Un seul « Composer » à l'écran : tant que le bouton de l'introduction est visible, la barre cache le sien
       mais reste là, avec « Tout au panier », seul chemin vers le panier ici (23/10). Sans ce bouton, elle se
       retire comme avant */
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (es) {
        var seen = es[es.length - 1].isIntersecting;
        bar.classList.toggle('is-solo', seen && !!all);
        bar.classList.toggle('is-away', seen && !all);
      /* « vu » = au-dessus de la barre : un bouton passé sous elle ne compte pas (29/10, c29t-favoris) */
      }, { rootMargin: '0px 0px -130px 0px' }).observe(iGo);
    }
    /* Le volet et le bas de page se calent sur la hauteur réelle de la barre (une ou deux rangées) */
    function barH() { var h = bar.offsetHeight; if (h) document.body.style.setProperty('--bvf-wl1-bar-h', h + 'px'); }
    if (window.ResizeObserver) new ResizeObserver(barH).observe(bar);

    function update() {
      decoAll();
      Array.prototype.forEach.call(body.querySelectorAll('[data-bvf-a2]'), paintA2);
      var list = items(), n = list.length;
      bar.classList.toggle('is-on', n > 0);
      intro.classList.toggle('is-on', n > 0);
      share.hidden = !body.querySelector('[data-bwl-share]');
      if (!n) return;
      nEl.textContent = n === 1 ? T.one : n + T.many;
      /* Les paliers comptent les tirages que « Tout au panier » met vraiment au panier : un épuisé
         (ou un cadre et un format sans stock) n'allume pas un palier qui ne s'appliquera pas (24/10) */
      var cards = body.querySelectorAll('[data-bwl-grid] .bwl-item');
      var addable = Array.prototype.filter.call(cards, function (c) {
        var a = c.querySelector('.bwl-item__add');
        return a && !a.disabled && a.getAttribute('data-variant');
      }).length;
      var built = Array.prototype.some.call(cards, function (c) { return c._p; });
      paintSteps(built ? addable : n);
      goT.textContent = n === 1 ? T.duo : T.wall;
      var ids = list.slice(0, 5).map(function (i) { return i.h; }).join(',');
      go.href = PLANNER + '?ids=' + encodeURIComponent(ids);
      iGoT.textContent = goT.textContent;
      iGo.href = go.href;
      barH();
    }
    update();
    modeFns.push(update);
    document.addEventListener('bisou:wishlist', function () { setTimeout(update, 80); });
    /* Un cadre ou un format changé peut tomber sur une variante épuisée : les paliers suivent. Pas en « Avant » :
       la barre y est cachée, et update() y remettrait l'ancienne image sur la carte qu'on vient de changer */
    body.addEventListener('change', function () { if (!isOff()) setTimeout(update, 80); });
    if (grid && window.MutationObserver) {
      var t;
      /* 28/10 : une carte arrivée prend sa tenue tout de suite, avant que le navigateur ne télécharge sa photo :
         à l'ordinateur, l'A4 noir posé par la carte partait 60 ms avant l'A2 qui le remplace, une photo pour rien par carte */
      new MutationObserver(function (ms) {
        clearTimeout(t); t = setTimeout(update, 60);
        ms.forEach(function (m) { Array.prototype.forEach.call(m.addedNodes, function (n) { if (n.classList && n.classList.contains('bwl-item')) deco(n); }); });
      }).observe(grid, { childList: true });
    }
  });
})();
